<footer class="prs-auth-site-footer" data-testing-id="auth-site-footer">
  <nav [attr.aria-label]="'login.footer.nav_label' | translate">
    <ul class="prs-auth-site-footer__links">
      <li class="prs-auth-site-footer__copy">
        {{ 'login.footer.copyright' | translate: { year: year } }}
      </li>
      @for (link of links; track link.labelKey) {
      <li>
        @if (link.href) {
        <a [href]="link.href" target="_blank" rel="noopener noreferrer">
          {{ link.labelKey | translate }}
          <span class="visually-hidden">{{ 'common.link.opens_new_tab' | translate }}</span>
        </a>
        } @else {
        <!-- CUSTOMIZATION: URL TBD (FR1.6.3) — render as text, not a dead href="#" link -->
        <span
          class="prs-auth-site-footer__pending"
          [attr.title]="'login.footer.link_url_pending' | translate"
        >
          {{ link.labelKey | translate }}
        </span>
        }
      </li>
      }
    </ul>
  </nav>
</footer>
